import { PropsWithChildren } from 'react';

import styles from './button-key.module.scss';

const ButtonKey = ({ children }: PropsWithChildren<any>) => {
    return <kbd className={styles.key}>{children}</kbd>;
};

export default ButtonKey;
